import http from "./client";
import ITelegramChat from "../typings/ITelegramChat";

async function list(course_id: number) {
  const response = await http.get(`/api/v2/telegram`, {
    params: { course_id: course_id }
  });
  return response.data;
}

async function get(id: number, course_id: number) {
  const response = await http.get(`/api/v2/telegram/${id}`, {
    params: { course_id: course_id }
  });
  return response.data;
}

async function status(id: number, course_id: number) {
  const response = await http.get(`/api/v2/telegram/${id}/status`, {
    params: { course_id: course_id }
  });
  return response.data;
}

async function create(telegramChat: ITelegramChat, course_id: number) {
  const response = await http.post(`/api/v2/telegram`, 
    { channelLink: telegramChat.link },
    { params: { course_id: course_id } }
  );
  return response.data;
}

async function update(telegramChat: ITelegramChat, course_id: number) {
  const response = await http.put(`/api/v2/telegram/${telegramChat.id}`,
    telegramChat,
    { params: { course_id: course_id } }
  );
  return response.data;
}

async function remove(id: number, course_id: number) {
  const response = await http.delete(`/api/v2/telegram/${id}`, {
    params: { course_id: course_id }
  });
  return response.data;
}

async function studentList(course_id: number) {
  const response = await http.get(`/api/v2/course/${course_id}/telegramchat`);
  return response.data;
}

const telegramChats = {
  list,
  get,
  status,
  create,
  update,
  remove,
  studentList,
}

export default telegramChats;